import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'

import ApiService from "./common/api.service";

// import money from './common/filters';

// Vue.use(money);

import MoneyFilter from "./common/money.filter";
import CurrencyFilter from "./common/currency.filter";
Vue.filter("money", MoneyFilter);
Vue.filter("currency", CurrencyFilter);

import CustomButton from '@/components/CustomButton.vue';
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'


Vue.component('custom-button', CustomButton)
Vue.component('VueSlider', VueSlider)

Vue.config.productionTip = false

ApiService.init();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#__surequote_app')
